import { render, staticRenderFns } from "./WidgetPromotion.vue?vue&type=template&id=1e9e38cc&"
import script from "./WidgetPromotion.vue?vue&type=script&lang=js&"
export * from "./WidgetPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports